"use strict";

/**
 * Stop area selector
 */
angular.module("app").directive("stopAreaSelector", ["ExploitationService", function (ExploitationService) {
	return {
		restrict: "E",
		templateUrl: "common/directives/stopAreaSelector/stopAreaSelector.html",
		replace: true,
		scope: {
			onStopAreaSelect: "&",
			selectedPoint: "="
		},
		link: function(scope, elt, attrs) {
			scope.data = {
				searchValue: "",
				stopAreas: []
			};
			scope.noResults = false;
			scope.searchStopAreas = function (searchPattern) {
				ExploitationService.searchStopPointsByName(searchPattern)
					.then((response) => {
						scope.data.stopAreas = response.data;
						scope.noResults = scope.data.stopAreas.length === 0;
						scope.selectedStopId = "";
					});
			};

			function setSelectedPoint(point) {
				scope.data.searchValue = point;
				console.log(scope.data.searchValue);
			};

			scope.selectStopArea = function(selected) {
				scope.onStopAreaSelect({stopArea: selected});
			};

			scope.$watch('selectedPoint', function(newVal, oldVal) {
				if (newVal !== oldVal) {
					// Appeler une fonction de mise à jour
					setSelectedPoint(newVal);
				}
			});

			// Utiliser $onChanges pour détecter les changements de propriétés
			scope.$onChanges = function(changesObj) {
				if (changesObj.selectedPoint && !changesObj.selectedPoint.isFirstChange()) {
					// Appeler une fonction de mise à jour
					setSelectedPoint(changesObj.selectedPoint);
				}
			};
		}
	};

}])
;